import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ApiError from '../utils/ApiError';

async function createFeedback(feedback) {
  const response = await fetch('/api/feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(feedback),
  });
  const data = await response.json();
  if (!response.ok) throw new ApiError(data.message, response.status);
  return data;
}

export default function useCreateFeedback() {
  return useMutation(createFeedback, {
    onSuccess: () => {
      toast('Thank you for your feedback', { type: 'success' });
    },
    onError: (error) => {
      toast(error.message || 'Failed to send feedback', { type: 'error' });
    },
  });
}
